module.exports = __webpack_public_path__ + "img/UsgsDarkRedSymbol.6070c5ad.svg";